import Image from 'gatsby-plugin-sanity-image';
import React from 'react';

export default function GridImage({
  image,
  width = 600,
  alt = 'Image',
  ...rest
}) {
  if (!image) return null;
  const height = undefined;
  return (
    <Image
      {...image}
      width={Array.isArray(width) ? width[width.length - 1] : width}
      // height={Array.isArray(height) ? height[height.length - 1] : height} // TODO height doesn't work due to a bug in sanity/image-url upstream library: https://github.com/sanity-io/image-url/issues/32
      // alt={brand.name}
      sizes={`(max-width: 40em) ${Array.isArray(width) ? width[0] : width}px, ${
        Array.isArray(width) ? width[width.length - 1] : width
      }px`}
      alt={alt}
      sx={{
        objectFit: 'contain',
        // Always ensure the images are full-width
        width: '100%',
        height,
        borderRadius: 'default',
      }}
      {...rest}
    />
  );
}
